import { type LayoutProps, type SiderProps } from 'antd5';

import { StyledLayout } from './Layout.style';

export function Layout(props: LayoutProps) {
  return <StyledLayout {...props} />;
}

export function Header(props: LayoutProps) {
  return <StyledLayout.Header {...props} />;
}

export function Footer(props: LayoutProps) {
  return <StyledLayout.Footer {...props} />;
}

export function Content(props: LayoutProps) {
  return <StyledLayout.Content {...props} />;
}

export function Sider(props: SiderProps) {
  return <StyledLayout.Sider {...props} />;
}

// components added to Layout to reflect how antd behaves
Layout.Header = Header;
Layout.Footer = Footer;
Layout.Content = Content;
Layout.Sider = Sider;
